module.exports = __webpack_public_path__ + "img/noVideo.ba9e89e3.svg";